module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap voice-trigger-wrap"
  }, [_c('button', {
    staticClass: "voice-trigger",
    class: {
      recording: _vm.recording, loading: _vm.loading
    },
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('toggle')
      }
    }
  }, [_c('span', {
    staticClass: "voice-trigger-badge"
  }, [_vm._v("IA")]), _vm._v(" "), _c('span', {
    staticClass: "voice-trigger-icon"
  }, [(_vm.recording) ? _c('span', {
    staticClass: "voice-trigger-pulse"
  }) : _vm._e(), _vm._v(" "), _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 15a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3Z",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 11a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.92V20H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-2.08A7 7 0 0 0 19 11Z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "voice-trigger-label"
  }, [_c('strong', [_vm._v("\n                " + _vm._s(_vm.loading ? 'Analyse en cours…' : (_vm.recording ? 'Enregistrement en cours…' : "Dicter les infos de l'intervention")) + "\n            ")]), _vm._v(" "), (_vm.loading) ? _c('small', [_vm._v("Cela peut prendre jusqu'à une minute")]) : (_vm.recording) ? _c('small', [_vm._v("Touchez pour arrêter")]) : _c('small', [_vm._v("Fonctionnalité pilote")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4082bbb5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/subcomponents/VoiceTriggerButton.vue
// module id = 754
// module chunks = 0